import { useState } from "react";
import { toastr } from "react-redux-toastr";
import { client, getApiErrorMessage } from "utils/api";

const SingleEvent = ({
  event,
  label,
  id,
  type,
  refetch,
  handleClose,
  refetchStatuses,
}) => {
  const [is_loading, setLoading] = useState(false);

  const triggerEvent = async ({ event, type, id }) => {
    try {
      setLoading(true);

      await client.post(`/channel_product_workflows/trigger_event`, {
        event,
        type,
        id,
      });
      if (!event.startsWith("begin_")) {
        refetchStatuses();
      }
      await refetch();
      toastr.success("Sukces", "Zaktualizowano");
    } catch (error) {
      toastr.error("Błąd", getApiErrorMessage(error));
    } finally {
      setLoading(false);
      handleClose();
    }
  };

  return (
    <button
      disabled={is_loading}
      type="button"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        triggerEvent({
          type,
          id: id,
          event,
        });
      }}
    >
      {is_loading ? "Proszę czekać..." : label}
    </button>
  );
};

export default SingleEvent;
